module.exports = __webpack_public_path__ + "img/ZJ5256.aa975499.png";